
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button, Grid, Tooltip } from '@mui/material'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

import formModel, { initialValues } from 'utils/formModels/special/goalsModel'
import { crudColorMap, crudIconMap } from 'utils/helpers'

import { ActionType } from 'types'
import { ScrollToError } from 'components/atoms/ScrollToError'
import { FlagCircle } from '@mui/icons-material'
import RichTextField from 'components/atoms/fields/RichTextField'

interface IProps {
  action: ActionType
  id: string
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}

const GoalsForm: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
 
  const [goalbankOpen, setGoalbankOpen] = useState(false)

  const {
    goals
  } = formModel()

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values: any) => {
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form>
            <ScrollToError/>
            <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>

              <Grid item xs={12}>

                <RichTextField
                  fieldProps={{ ...goals }}
                  label={goals.label}
                  disabled={false}
                />

              </Grid>
              <Grid item xs={12}>
                <Tooltip title={`${t('common.select-from-goalbank')}`} arrow placement='top'>
                          <Button
                            onClick={() => setGoalbankOpen(true)}
                            aria-label={`${t('common.select-from-goalbank')}`}
                            size='small'
                            disabled={viewOnly}
                            color='success'
                            variant='contained'
                            sx={{ boxShadow: 'none', width: '100%', minHeight: '47px' }}
                          >
                            <FlagCircle style={{ fontSize: '1.5rem', marginRight: '10px' }} /> {t('common.select')}
                          </Button>
               </Tooltip>
              </Grid>

              <Grid item xs={12}>
                <SubmitButton
                    color={crudColorMap[action]}
                    text={`Save`}
                    icon={crudIconMap[action]}
                    sx={{ width: '10rem' }}
                    isLoading={false}
                />
              </Grid>
            </Grid>

            {/*
              <DialogPopup
                  title={t('common.goalbank')}
                  open={goalbankOpen}
                  onClose={() => setGoalbankOpen(false)}
                  popupWidth={'1000px'}
                >
                  <GoalbankPage selectHandler={ (goal: any) => {
                      let newValue =  values?.goals + (values?.goals ? "<br>" : "") + goal.text;
                      setFieldValue(goals.name, newValue)
                      setGoalbankOpen(false);
                    }
                  } />
              </DialogPopup>
              */}
        


          </Form>
        )
      }}
    </Formik>
  )
}

export default GoalsForm
